import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { ProductEmbedMarkup } from "./product-embed-markup"

// This component is rendered at save time. We capture the resulting HTML and
// save it to the server. The goal here is to render the same component as
// before, but with Liquid as the content. We can still access anything from
// `properties` (which are the sidebar settings) to conditionally show content
// or grab the product id.

export function ProductEmbedEmail({ id }) {
  const { properties } = useBlocks(id)

  const pid = properties.productId

  const liquidData = {
    title: "{{ product.title }}",
    name: "{{ product.name }}",
    imageUrl: "{{ product.image }}",
    imageAlt: "{{ product.imageAlt }}",
    description: "{{ product.description }}",
    price: "{{ product.price }}",
    url: "{{ product.url }}",
    buttonText: "{{ product.button_text }}"
  }

  let options = ""
  if (properties.goDirectlyToCheckout) {
    options += ", link_to_checkout: true"
  }
  if (properties.includeDiscount && properties.discountCode) {
    options += `, coupon_code: ${properties.discountCode}`
  }

  return (
    <>
      {`{% product ${pid}${options} %}`}
      <ProductEmbedMarkup properties={properties} productData={liquidData} />
      {`{% endproduct %}`}
    </>
  )
}
